export function checkInput(text, maxLen = 500) {
    if (text === '') {
        return { isLongEnough: true, hasOnlyAllowed: true, disallowedChars: [] };
    }
    const allowedRegex = /^[A-Za-z0-9\s.,!?;:'"()[\]{}<>@#\p{Sc}%^&*_+\-=/\\|~`]+$/u;

    const isLongEnough = text.length <= maxLen;
    const hasOnlyAllowed = allowedRegex.test(text);

    const disallowedChars = Array.from(text).filter(
        ch => !ch.match(/[A-Za-z0-9\s.,!?;:'"()[\]{}<>@#\p{Sc}%^&*_+\-=/\\|~`]/u)
    );

    return { isLongEnough, hasOnlyAllowed, disallowedChars };
}
